"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _constructor = _interopRequireDefault(require("../../../constants/constructor"));

var _router = require("../../../constants/router");

var _regExpEscape = _interopRequireDefault(require("../../utils/regExpEscape"));

/* istanbul ignore file */
// constants
// utils
class RouteWithConstraintsDecorator {
  [_constructor.default]() {
    this.constraints = {};
  }
  /**
   * @param {string} constraintName
   * @param {RegExp} validator
   */


  setConstraint(constraintName, validator) {
    this.constraints[constraintName] = validator;
    return this;
  }

  setConstraints(constraints) {
    this.constraints = constraints;
  }

  getConstraint(constraintName) {
    return this.constraints[constraintName];
  }

  getConstraints() {
    return this.constraints;
  }
  /**
   * @param {Uri} uri
   * @return {object?}
   */


  match(uri) {
    const orderedConstraints = [];
    const self = this;
    const regexp = new RegExp((0, _regExpEscape.default)(this.uri.toString()).replace(_router.constraintRegexp, function (match, constraintName) {
      /**
       * @var {RegExp} validator
       */
      const validator = self.getConstraint(constraintName);
      orderedConstraints.push(constraintName);
      return `(${validator.source})`;
    }));
    const match = regexp.exec(uri.toString());

    if (match) {
      const parameters = {};
      const [, ...parameterMatches] = match;

      for (const [index, parameter] of Object.entries(parameterMatches)) {
        const parameterName = orderedConstraints[index];

        if (
        /**
         * If the same constraint name is used twice is the given url,
         *   but with different values.
         */
        Object.prototype.hasOwnProperty.call(parameters, parameterName) && parameters[parameterName] !== parameter) {
          return undefined;
        }

        parameters[parameterName] = parameter;
      }

      return {
        parameters
      };
    } else {
      return undefined;
    }
  }

}

exports.default = RouteWithConstraintsDecorator;